import React,{useCallback, useEffect, useRef, useState} from 'react'
import './SHeader.css';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { LoginService } from '../services/LoginService';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchPatientProfileData } from '../reduxactions/patientactions/PatientProfileActions';

import { Divider } from 'primereact/divider';
import eventBus from '../doctorapprover/eventBus';
import { fetchFamilyData } from '../reduxactions/patientactions/PatientFamilyActions';
import { PATIENT_API } from '../ApiNames';
import { useNavigate } from 'react-router-dom';
type Nullable<T> = T | null;

var imageuser = require('../assets/img/medi.png');
var projecticon = require('../assets/img/medicaaal.png');
var defaultimage = require('../assets/img/images.png');

export const PHeader = () => {
    const op = useRef(null as any);
    const photos = window.sessionStorage.getItem('photo');
    const uid = window.sessionStorage.getItem('uid');
  
  
  
    const imgSrc =  imageuser;
  
    const usertype = window.sessionStorage.getItem('usertype');
    const username = window.sessionStorage.getItem('username');
    const formattedUsertype = usertype ? usertype.charAt(0).toUpperCase() + usertype.slice(1).toLowerCase() : '';
    const [photo,setPhoto]=useState<any>(null);
    console.log("HeaderPhoto",photo)
    // useEffect(()=>{
    //   if(photos !== photo){
    //     // const photos = window.sessionStorage.getItem('photo');
    //     setPhoto(photos);
    //   }
    // },[setPhoto,photo,photos]);
    const fetchSessionPhoto = useCallback(async () => {
      try {
        const photoUrl = window.sessionStorage.getItem('photo');
        setPhoto(photoUrl);
      } catch (error) {
        console.error('Error fetching session photo:', error);
      }
    }, []);
    useEffect(() => {
      const handlePhotoUpdate = (newPhoto:any) => {
        setPhoto(newPhoto);
      };
      eventBus.on('photoUpdated', handlePhotoUpdate);
  
      return () => {
        eventBus.off('photoUpdated', handlePhotoUpdate);
      };
    }, []);
    
    useEffect(() => {
      fetchSessionPhoto();
    
      const handleStorageChange = () => {
        if (window.sessionStorage.getItem('photo') !== photo) {
          fetchSessionPhoto();
        }
      };
    
      window.addEventListener('storage', handleStorageChange);
    
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, [fetchSessionPhoto, photo]);
  console.log(photo,"head")
  
    const handleLogout = () => {
      window.sessionStorage.removeItem('usertype');
  
    };
    const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.patientprofile.data);
    const fetchDataAsync = async () => {
      try {
          await dispatch(fetchPatientProfileData(uid) as any);
      } catch (error) {
          console.error('Error fetching data:', error);
      }
  };
  useEffectOnce(() => {
      fetchDataAsync();
  }, [dispatch]);

  //for header family 
      const familydata = useSelector((state: RootState) => state.patientfamily.family);

      
      const [familyMembers,setFamilyMembers]=useState([]);
  const fetchFamilyHeaderData = async () => {
          try {
            const payload = {userid:uid,q:3};
            const apiname = PATIENT_API.family_API;
            const response = await LoginService.getData(apiname,payload);
            setFamilyMembers(response);
          } catch (error) {
              console.error('Error fetching data:', error);
          }
      };
      
      const [isOption,setIsOption]=useState(false);
      const handleToggle = ()=>{
        setIsOption(!isOption)
      }
      const [uname,setUName]=useState('')
      const [utype,setUsertype]=useState('')
      const [uemail,setUemail]=useState('')
      const [uuid,setuuid]=useState('')
      const navigate= useNavigate()
      const loginPatient = async (patientid:any)=>{
        try {
          const payload = {userid:patientid,q:4};
          const apiname = PATIENT_API.family_API;
          const response = await LoginService.getData(apiname,payload);
          console.log(response,"res");
          setUName(response[0]?.username);
          setUsertype(response[0]?.usertype);
          setUemail(response[0]?.email);
          setuuid(response[0]?.userid);
          sessionStorage.setItem('uid',uuid)
            sessionStorage.setItem('email',uemail);
            sessionStorage.setItem('usertype',utype);
            sessionStorage.setItem('name',uname);
            if(usertype == utype){
              window.location.reload();
              navigate('/patientcases');
              }
          
        } catch (error) {
            console.error('Error fetching data:', error);
        }
      }
      
      useEffect(() => {
        fetchFamilyHeaderData();
      }, [dispatch]);
  return (

    <div className="layout-topbar" style={{ backgroundColor: 'rgb(255, 193, 7)', color: 'rgba(0, 0, 0, 0.7)', display: 'flex', alignItems: 'center' }}>
      <div className="layout-topbar-logo" style={{ flex: 1 }}>
      {/* <span ><i className="pi pi-bars" style={{width:'40px'}}></i></span> */}
      {/* <span style={{marginLeft:'20px'}}> */}
      <span>
        <img src={imageuser} alt="Logo" width="50px" height="100%" />
        <img src={projecticon} alt="Logo" width="200px" height="100%" />
        </span>
        
      </div>
      {familydata !== '' && (
  <>
    <div className="dropdown-divider"></div>
    <div 
      style={{ position: 'relative', display: 'inline-block' }}
    >
      <a 
        className="dropdown-item"
        style={{ textDecoration: 'none', cursor: 'pointer',marginRight:'200px' }}
        onClick={handleToggle}
      >
        <div className="media">
          <i className="pi pi-users"></i>
          <span>Family</span>
        </div>
      </a>
      {isOption && (
  <ul 
    className="dropdown-menu" 
    style={{ 
      listStyleType: 'none', 
      padding: '5px', 
      margin: 0, 
      position: 'absolute', 
      top: '160%',
      left: 0, 
      zIndex: 1000, 
      backgroundColor: 'white', 
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', 
      borderRadius: '4px',
    }}
  >
    {familyMembers.map((item: any, index: any) => (
      <li 
        key={index} 
        style={{ 
          marginBottom: '10px', 
          display: 'flex', 
          justifyContent: 'center', 
        }}
      >
        <button
          style={{
            backgroundColor: 'white',
            border: 'none',
            padding: '12px 8px',
            color: 'black',
            textAlign: 'center',
            borderRadius: '6px',
            width: '150%',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          }}
        >
          <span style={{ fontSize: '14px' }} onClick={()=>loginPatient(item.patientid)}>{`${item.patientname}`}</span>
        </button>
      </li>
    ))}
  </ul>
)}

    </div>
  </>
)}


    
          <a  className="nav-link"  onClick={(e) => op.current.toggle(e)} style={{textDecoration: 'none', marginLeft: '15px',float:'right'}}>
          <img src={photo || defaultimage} className="avatar" alt="User Image" />
            <span className="hidden-xs" style={{color: 'rgba(0, 0, 0, 0.7)', fontSize: '1.2rem',fontWeight:'400',fontFamily: 'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif',marginLeft:'10px'}}>{username} - {formattedUsertype}</span>
          </a>
         
      <ul className="navbar-nav ml-auto">
      
        <OverlayPanel ref={op}>
          <div className="dropdown-divider"></div>
          <a className="dropdown-item" style={{textDecoration: 'none'}}>
            <div className="media">
            <a href={`${process.env.PUBLIC_URL}/patientprofile`} style={{ textDecoration: 'none' }}>Profile</a>
                <Divider />
                 <a href={`${process.env.PUBLIC_URL}/patientresetpassword`} style={{ textDecoration: 'none'}}>Reset Password</a>
                 <Divider />
              {/* <a href="/patientprofile" style={{textDecoration: 'none'}}>Profile</a>
              <Divider />
              <a href="/dresetpassword" style={{textDecoration: 'none'}}>Reset Password</a>
              <Divider /> */}
              <a href="/" style={{textDecoration: 'none'}}>Sign out</a>
              </div>
              </a>
        </OverlayPanel>
      </ul>
    </div>
    

    );
};

PHeader.displayName = 'AppTopbar';

export default PHeader;

